import { useState } from 'react'
import styled from 'styled-components'
import { courseContentTypes } from '../utils/courseContentTypes'
import { colors, measurments } from '../utils/config'
import { CourseContent, LucideIconName } from '@bm-js/atlascloud-shared'
import { Icon } from '@bm-js/atlascloud-ui'

const StyledCourseContentSelector = styled.div`
  .content-type-button {
    button {
      cursor: pointer;
      background: ${colors.primary400};
      border: none;
      border-radius: ${measurments.borderRadius}px;
      color: ${colors.white};
      font-weight: 500;
      font-size: 14px;
      padding: 0.5rem 1rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      &:hover {
        background: ${colors.primary300};
      }
    }
  }
  .content-types {
    display: flex;
    flex-wrap: wrap;
    max-height: 0;
    overflow: hidden;
    padding: 0;
    margin: 0;
    transition: 200ms ease-in-out;
    gap: 0.4rem;
    .content-type {
      display: flex;
      border-radius: ${measurments.borderRadius}px;
      padding: 0.4rem 1rem;
      background: ${colors.primary400};
      align-items: center;
      cursor: pointer;
      p {
        white-space: nowrap;
        margin-right: 0.5rem;
        font-size: 14px;
        color: white;
      }
      transition: 200ms ease-in-out;
      &:hover {
        background: ${colors.primary300};
      }
    }
  }
  &.is-open {
    .content-types {
      max-height: 200px;
      margin-top: 0.5rem;
    }
  }
`

type Props = {
  addContent: (content: CourseContent) => void
}

const CourseContentSelector = ({ addContent }: Props) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <StyledCourseContentSelector className={isOpen ? 'is-open' : ''}>
      <div className='content-type-button'>
        <button onClick={() => setIsOpen(!isOpen)} type='button'>
          <span>Lägg till innehåll</span>
          <span className='text-white'>
            <Icon
              name={isOpen ? LucideIconName.X : LucideIconName.Plus}
              className='size-5'
            />
          </span>
        </button>
      </div>
      <div className='content-types'>
        {courseContentTypes.map((contentType) => (
          <div
            className='content-type'
            key={contentType.type}
            role='button'
            onClick={() => {
              addContent(contentType)
              setIsOpen(false)
            }}
          >
            <p className='m0'>{contentType.name}</p>
            <span className='text-white'>
              <Icon name={contentType.icon} className='size-5' />
            </span>
          </div>
        ))}
      </div>
    </StyledCourseContentSelector>
  )
}

export default CourseContentSelector
